import { StyleSheet } from 'react-native'
import { Theme } from '@theme'

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    modalOverlay: {
      flex: 1,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      justifyContent: 'flex-end',
    },
    modalContainer: {
      backgroundColor: theme.colors.white,
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
      paddingBottom: 34, // Safe area bottom
      maxHeight: '80%',
    },
    modalHeader: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingHorizontal: theme.spacing.lg,
      paddingVertical: theme.spacing.lg,
      borderBottomWidth: 1,
      borderBottomColor: theme.colors.lightGrey,
    },
    headerLeft: {
      flex: 1,
    },
    modalTitle: {
      color: theme.colors.secondary,
      fontSize: theme.fontSize.large,
      fontWeight: 'bold',
      marginBottom: theme.spacing.xs,
    },
    memberCount: {
      color: theme.colors.primary,
      fontSize: theme.fontSize.medium,
    },
    closeButton: {
      padding: theme.spacing.xs,
    },
    membersList: {
      paddingHorizontal: theme.spacing.lg,
      minHeight: 300,
    },
    memberItem: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingVertical: theme.spacing.md,
      borderBottomWidth: 1,
      borderBottomColor: theme.colors.lightGrey,
    },
    memberInfo: {
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1,
    },
    memberAvatar: {
      width: 40,
      height: 40,
      borderRadius: 20,
      marginRight: theme.spacing.md,
    },
    memberName: {
      color: theme.colors.secondary,
      fontSize: theme.fontSize.medium,
      flex: 1,
    },
    adminIndicator: {
      width: 4,
      height: 40,
      backgroundColor: theme.colors.primary,
      borderRadius: 2,
    },
    removeButton: {
      padding: theme.spacing.sm,
    },
  })

export default getStyle 